/**
 * ajax-cart.js = Handles the mini-cart functionality.
 */


jQuery(function($) {

   /**
    * Handle add to cart ajax buttons.
    */
   $('.btn-ajax-atc').click(function(e) {
      var $button = $(this);
      var $id = $button.data('id');

      $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         data: { quantity: 1, id: $button.data('id') },
         dataType: 'json',
         success:  function(result) {
            window.forceCartRefresh();
         },
         error: function(result) {
            var $realResult = result.responseJSON;
            if ($realResult) {
               alert($realResult.message + " - " + $realResult.description);
            }
            else {
               alert("Failed to add to cart for unknown reason, please try again later.");
            }
         },
      });

      e.preventDefault(0);
      return false;
   });


   /**
    * Tell the cart to refresh it's contents.
    */
   window.forceCartRefresh = function() {
      jQuery.getJSON('/cart.js', function(cart) {
         window.dispatchEvent(new CustomEvent('onCartUpdate', { detail: cart }));
      });
   };


   /**
    * The event fired when the cart is asked to update.
    */
   window.addEventListener('onCartUpdate', function(event) {
      var cart = event.detail;
      window.currentCart = cart;
      if (cart.item_count > 0) {
         
            $('span[data-event="onCartUpdate"][data-value="item_count"]').removeClass('d-none').text(cart.item_count);
         
      }
      else {
         $('span[data-event="onCartUpdate"][data-value="item_count"]').addClass('d-none').text(cart.item_count);
      }
      window.populateMiniCart();
   });


   /**
    * Simple money formatter.
    * @param n The value.
    * @param x The decimal places (default = 2)
    */
   Number.prototype.formatMoney = function(n, x) {
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
      return "£" + this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
   };


   /**
    * The render function for populating the cart visually.
    */
   window.populateMiniCart = function() {
      var $target = $('.cart-dropdown-menu');
      if (window.currentCart && $target.length > 0) {
        var currency_symbol = window.getCurrentSelectedRateSymbol();
         var $cart = window.currentCart;
         
         /* 1. Clear minicart contents. */
         $target.html('');

         /* 2. Populate line items */
         for(var $i=0; $i<$cart.items.length && $i<3; $i++) {
            var $item = $cart.items[$i];

            var item_price = window.convertNumberToRate($item.price);
            var item_price = (item_price/100).toFixed(2);
            var item_price_html = currency_symbol + item_price;

            var $image = $item.image.replace(".jpg", "_95x95.jpg");

            var $fragment = '<div class="dropdown-item-x pl-2 pr-2" style="width:350px;">\n'
                          + '  <div class="row">\n'
                          + '    <div class="col-sm-9">\n'
                          + '      <h6><a href="' + ($item.url) + '">' + ($item.product_title) + '</a></h6>\n'
                          + '      <span class="text-muted">'+ $item.quantity + ' x ' + item_price_html + '</span>\n'
                          + '        <a class="badge badge-secondary" href="/cart/change?line=' + ($i+1) + '&amp;quantity=0">Remove</a>'
                          + '    </div>'
                          + '    <div class="col-sm-3">'
                          + '      <img src="' + ($image) + '" class="{&quot;crop&quot;=>&quot;center&quot;}">'
                          + '    </div>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="dropdown-divider ml-2 mr-2"></div>';

            $target.append($fragment);
         }

         if ($cart.items.length > 3) {
            var $remainder = $cart.items.length - 3;
            $target.append('<div class="dropdown-item-x p-1 pb-0 pl-2 pr-2 text-center"><a href="/cart">+ ' + $remainder + ' more item(s)...</a></div>');
            $target.append('<div class="dropdown-divider ml-2 mr-2"></div>');
         }

         /* 3. Add the sub total */
         $target.append(
            '<div class="dropdown-item-x p-1 pb-0 pl-2 pr-2 text-right">' +
            '  <div class="text-muted h6 mb-0"><strong>Subtotal:</strong><span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_total" style="display:none !important;"></span> ' + ($cart.total_price / 100).formatMoney(2) + '</div>' +
            '</div>' +
            '<div class="dropdown-divider ml-2 mr-2"></div>' +
            '<div class="dropdown-item-x pl-2 pr-2 text-right">' +
            '  <a href="/cart" class="btn btn-link">View Basket</a>' +
            '  <a href="/checkout" class="btn btn-primary">Checkout</a>' +
            '</div>'
         );

         /* 4. Refresh BOLD multi currency */
         var currency_name = $('.BOLD-mc-picker-mnt .currentCurrency .name').html();

         var currency_target = $('.BOLD-mc-picker-mnt .currencyList li[data-value="'+currency_name+'"]');

         $(currency_target).click();
      }
      
   };

   /**
    * 
    */
   window.initProductPageAjax = function() {
      var selectors = $('select[data-single-option-selector]');
      if (selectors.length > 0) {
        var currency_name = window.getCurrentSelectedRate();
        if(currency_name == '•••')
        {
          setTimeout(window.initProductPageAjax, 200);
        }
        else
        {
          selectors.change(function(selectorClickEvent) {
            window.productPageAjaxUpdate(selectors, selectorClickEvent);
          });
          selectors.first().trigger('change');
        }
      }
   }
    

  window.getExchangeRates = function(){
    var exchange_rates = {'currencies':{'GBP':{'rate':1, }}, 'all_currencies':{'GBP':{'symbol':'£'}}};

    $.ajax({
        url: 'https://mc.boldapps.net/perfume-direct-jarilo.myshopify.com/rates',
        success: function(data){
          exchange_rates = data;
        },
        'error':function(data){
          console.log(data);
        },
        'async':false
      });

    return exchange_rates;
  }

  window.convertNumberToRate = function(number)
  {
      var currency_name = window.getCurrentSelectedRate();
      var exchange_rates = window.getExchangeRates();

      if(exchange_rates.currencies.hasOwnProperty(currency_name))
      {
         return number * exchange_rates.currencies[currency_name].rate;
      }

      return number * 1;
  }

  window.getCurrentSelectedRateSymbol = function(){
    var currency_name = window.getCurrentSelectedRate();
      var exchange_rates = window.getExchangeRates();

      if(exchange_rates.all_currencies.hasOwnProperty(currency_name))
      {
         return exchange_rates.all_currencies[currency_name].symbol;
      }

      return '£';
  }

  window.getCurrentSelectedRate = function()
  {
    var currency_name = $('.BOLD-mc-picker-mnt .currentCurrency .name').html();
    return currency_name;
  }

   /**
    * When an option on a product page changes, this is called to update
    * the displayed price and stock info dynamically.
    */
   window.productPageAjaxUpdate = function(selectors, clickEvent) {
      
      var currency_symbol = window.getCurrentSelectedRateSymbol();

      if (selectors.length > 0) {
         var query = {
            option1: $('select[data-single-option-selector][data-index="option1"]').val() || "",
            option2: $('select[data-single-option-selector][data-index="option2"]').val() || "",
            option3: $('select[data-single-option-selector][data-index="option3"]').val() || ""
         };

         var option = null;
         var product_id = Object.keys(window.productMetas)[0];
         var product_meta = window.productMetas[product_id];
         var matched = false;

         for (var i=0; i<product_meta.variants.length; i++) {
            var variant = product_meta.variants[i];
            var v_price = window.convertNumberToRate(variant.price);
            v_price = (v_price/100).toFixed(2);

            if (variant.option1 == query.option1 && variant.option2 == query.option2 && variant.option3 == query.option3) {
               /* Select the correct variant. */
               $('select[data-product-select]').val(variant.id);

               /* Set the variant price */
               var priceHtml = currency_symbol + (v_price);
               if (variant.compare_at_price > variant.price) {
                  priceHtml = "<ins data-product-price>" + (v_price / 100).formatMoney(2) + "</ins>\n"
                            + "<del data-compare-price>" + (variant.compare_at_price / 100).formatMoney(2) + "</del>";
               }

               $('.product-item-price').html(priceHtml);

               /* Set the quantity label and maximum */
               var qtyLabel = $('label[for="Quantity"]');
               qtyLabel.removeClass('text-danger').text("Quantity (" + variant.inventory_quantity + " available)");
               if (variant.inventory_quantity <= 0) {
                  qtyLabel.addClass('text-danger');
               }
               $('#Quantity').prop('max', variant.inventory_quantity);
               
               /* Enable or disable the buy button depending on availability */
               $('#buyButton').prop('disabled', variant.inventory_quantity <= 0);
               
               matched = true;
               break;
            }
         }

         if (!matched) {
            console.log("Faield to match :(");
         }
      }
   }


   /**
    * Initially force a cart refresh.
    */
   window.forceCartRefresh();
   window.initProductPageAjax();

});